import { schema } from "normalizr";
import { AccountCarrier as AccountCarrierRecord } from "records/shipping-accounts";

export const AccountCarrier = new schema.Entity(
    "accountCarrier",
    {},
    {
        idAttribute: "id",
    }
);

(AccountCarrier as any).record = AccountCarrierRecord;
